module.exports = __webpack_public_path__ + "static/media/thumbnail.2f414d10.jpg";